import {animate, style, transition, trigger} from "@angular/animations"

export const fadeInPlaceholderAnimation = trigger("fadeInPlaceholder", [
    transition("void => *", [style({opacity: 0.4}), animate("300ms", style({opacity: 1}))]),
])
